// eslint-disable-next-line no-shadow
export enum GenericIconEnum {
  PACKAGE_OPEN = 'box-open-black-32',
  ANTIVIRUS = 'shield-virus-black-32',
  SIM_CARD = 'sim-black-32',
  ADVISOR = 'advisor',
  SECURE_EMAIL = 'secure_email',
  FIBER = 'gimmick-fibre-black-32',
  MOBILE = 'mobile-signal-out-black-32',
  NEOSAT_COOL = 'neosat_cool',
  NORDNETBOX_WIFI = 'nordnetbox_wifi',
  PAUSE = 'circle-pause-black-32',
  WIFI_REPEATER = 'wifi_repeater',
  CLOSE = 'close_1',
  QUESTION_CIRCLE = 'circle-question-black-16',
}

// eslint-disable-next-line no-shadow
export enum GenericIconSize {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
  INHERIT = 'inherit',
}
